import {PriceSummary as PriceSummaryV1} from '@wix/auto_sdk_ecom_current-cart';
import {V2TaxSummary as TaxSummary} from '@wix/auto_sdk_ecom_cart-v-2';
import {TaxModel} from './Tax.model';
import {ModelContext, TaxSummaryV1WithPrivateFields} from '../../../types/app.types';
import {SPECS} from '../../specs';

export class TaxSummaryModel {
  public taxes: TaxModel[];

  constructor(params: TaxSummaryModel) {
    this.taxes = params.taxes;
  }

  public static fromCartV1(
    taxSummary: TaxSummaryV1WithPrivateFields | undefined,
    priceSummary: PriceSummaryV1 | undefined,
    modelContext: ModelContext
  ) {
    if (
      modelContext.viewerContext.isExperimentEnabled(SPECS.TaxBreakdownInCartPage) &&
      taxSummary?.aggregatedTaxBreakdown?.length > 0
    ) {
      return new TaxSummaryModel({
        taxes: taxSummary.aggregatedTaxBreakdown.map(({taxName, aggregatedTaxAmount}) =>
          TaxModel.fromCartV1(
            {
              taxName,
              amount: aggregatedTaxAmount,
            },
            modelContext
          )
        ),
      });
    }

    return new TaxSummaryModel({
      taxes: [
        TaxModel.fromCartV1(
          {
            taxName: modelContext.viewerContext.isExperimentEnabled(SPECS.MoveCartToViewerContext)
              ? taxSummary?.taxName ?? ''
              : modelContext.taxNameOld ?? '',
            amount: priceSummary?.tax,
          },
          modelContext
        ),
      ],
    });
  }

  public static fromCartV2(taxSummary: TaxSummary, modelContext: ModelContext): TaxSummaryModel {
    return new TaxSummaryModel({
      taxes: taxSummary.taxes?.map((tax) => TaxModel.fromCartV2(tax, modelContext)),
    });
  }
}
